module.exports = __webpack_public_path__ + "img/gb9877_1-88-38x55x8.prt.cb3dbf7f.jpg";